export const FEATURE_NAME = '@vshosting/cdn/features/warm-log-dialog';
